import { createContext, useContext } from 'react'

export type AuthCtx = {
  initialized: boolean
  authenticated: boolean
  /** Display-only claims — do NOT use for access control (the gateway enforces that). */
  claims: { email?: string; name?: string; assetId?: string } | null
  login: () => void
  logout: () => void
}

// Kept separate from AuthProvider.tsx so that file exports only the component
// (react-refresh / Fast Refresh requires component-only modules).
export const Ctx = createContext<AuthCtx>(null!)

export const useAuth = () => useContext(Ctx)
